import { HeaderSolutionProps } from "../../../../components/header-solution";
import { ParticipationHeaderProps } from "./../types";
import { useCountdownTimer } from "./../useCountdownTimer";
import { SOLUTION_TIMER_KEY } from "./../constants";

export function useSolutionHeaderProps({
  currentSet,
  currentItemIndex,
}: ParticipationHeaderProps): HeaderSolutionProps {
  const item = currentSet.items[currentItemIndex];
  const category = currentSet.scales.find(
    scale => scale.category === item.category
  );
  const headLine = item.v1;
  const subHeadLine = item.v2;
  const helpText = item.v3;

  const countdownTime = useCountdownTimer(SOLUTION_TIMER_KEY);

  return {
    topLabels: [category?.scaleName ?? "", [headLine, subHeadLine]],
    sidePanelContent: helpText,
    countdownTime,
  };
}
